"use client";

import {useEffect} from "react";
import {isCookiebotAnalyticsConsentGiven} from "@/utils/analytics/cookiebot";

const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim();
const CLARITY_SCRIPT_ID = "reputech-clarity";

export function ClarityScript() {
  useEffect(() => {
    if (!CLARITY_PROJECT_ID) return;

    const loadClarity = () => {
      if (!isCookiebotAnalyticsConsentGiven() || document.getElementById(CLARITY_SCRIPT_ID)) return;
      const script = document.createElement("script");
      script.id = CLARITY_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${encodeURIComponent(CLARITY_PROJECT_ID)}`;
      document.head.appendChild(script);
    };

    loadClarity();
    window.addEventListener("CookiebotOnLoad", loadClarity);
    window.addEventListener("CookiebotOnAccept", loadClarity);
    window.addEventListener("CookiebotOnConsentChanged", loadClarity);

    return () => {
      window.removeEventListener("CookiebotOnLoad", loadClarity);
      window.removeEventListener("CookiebotOnAccept", loadClarity);
      window.removeEventListener("CookiebotOnConsentChanged", loadClarity);
    };
  }, []);

  return null;
}
